import * as yup from 'yup';

const hasSelectedValue = (value: unknown): boolean => {
  if (Array.isArray(value)) {
    return value.length > 0;
  }

  return value !== undefined && value !== null && value !== '';
};

const readDisplayName = (parent: unknown): string => {
  if (
    typeof parent === 'object' &&
    parent !== null &&
    'displayName' in parent
  ) {
    // TypeScript 4.4 does not narrow on `in`; the value is still re-checked below.
    const { displayName } = parent as { displayName: unknown };
    if (typeof displayName === 'string' && displayName.trim() !== '') {
      return displayName;
    }
  }

  return 'This attribute';
};

/**
 * Per-row rule for a claimAttributes field array: rows whose attribute
 * definition is pinned must have at least one selected value. The error lands
 * on the row's own `selectedAttributeValuesVarchars` path.
 *
 * `mixed` rather than `array`: a single-select value is stored as a string,
 * and unpinned rows must get no new validation at all.
 */
export const buildPinnedClaimAttributesSchema = (
  pinnedGuids: readonly string[]
): yup.AnySchema =>
  yup.array().of(
    yup.object({
      selectedAttributeValuesVarchars: yup
        .mixed()
        .when('attributeDefinitionIntegrationGUID', {
          is: (guid: unknown) =>
            typeof guid === 'string' && pinnedGuids.includes(guid),
          then: (schema: yup.AnySchema) =>
            schema.test(
              'pinned-claim-attribute-required',
              'This attribute is required',
              function (value: unknown) {
                return (
                  hasSelectedValue(value) ||
                  this.createError({
                    message: `${readDisplayName(this.parent)} is required`,
                  })
                );
              }
            ),
        }),
    })
  );
